// extracted by mini-css-extract-plugin
export default {"customTooltip":"Breakdowns_customTooltip__AbimD","tooltipLabel":"Breakdowns_tooltipLabel__fzHWG","tooltipValue":"Breakdowns_tooltipValue__yxghd"};